import { Component } from '@angular/core';
import { Language } from '@libraries/design-system';
import { FeaturesService } from '@libraries/feature-flags';
import { Environment } from '@libraries/shared-env';
import { Store } from '@ngrx/store';
import { getPreferredLanguage, SwitchPreferredLanguage } from '../../state';

@Component({
  selector: 'header-wrapper',
  templateUrl: './header-wrapper.component.html',
  styleUrls: ['./header-wrapper.component.scss'],
  standalone: false,
})
export class HeaderWrapperComponent {
  preferredLanguage$ = this.store.select(getPreferredLanguage);

  constructor(public env: Environment, private store: Store, public features: FeaturesService) {}

  toggleLanguage(language: Language) {
    this.store.dispatch(
      SwitchPreferredLanguage({
        preferredLanguage: language,
      })
    );
  }
}
